// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import { i18n } from '../../index'
import { Mutation } from 'react-apollo'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '@mui/material/Button'
import { updateStation } from '../../station/stationQueries'
import type { Station } from '../../station/stationTypes'
import css from './stationForm.css'
import { WEEK_NUMBERS } from '../menu/menuConstants'
const defaultFormData = {
  id: '',
  name: '',
  address: '',
  salesIncentiveUnit: 'Pieces',
  buffetGroup: 0,
  buffetBeginAt: '10:30:00',
  buffetEndAt: '13:00:00',
  buffetWeights: [],
}
type BuffetGeneralFormProps = {
  data: Station
}
type BuffetGeneralFormState = {
  formData: Station
}

class BuffetGeneralForm extends React.PureComponent<BuffetGeneralFormProps, BuffetGeneralFormState> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setStateFromData(data)
    }
  }

  componentDidUpdate(prevProps: BuffetGeneralFormProps) {
    const { data } = this.props

    if (data && !isEqual(data, prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: Station) => {
    this.setState({
      formData: { ...defaultFormData, ...data },
    })
  }
  onInput = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  isValid = () =>
    !isEqual(
      omit(this.props.data, ['buffetWeights', 'profitCenters']),
      omit(this.state.formData, ['buffetWeights', 'profitCenters']),
    )
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { formData } = this.state
    const station: Station = { ...formData }
    onMutate({
      variables: {
        id: station.id,
        data: omit(station, ['id', 'buffetWeights', 'profitCenters', 'company', 'users', 'reminders', '__typename']),
      },
    })
  }

  render() {
    const { formData } = this.state
    return (
      <Mutation mutation={updateStation}>
        {(onMutate) => (
          <form noValidate onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.component}>
            <div className={css.radioGroup}>
              <FormLabel required component='legend' className={css.formLabel}>
                {i18n.t('admin.stations.label.buffetGroup')}
              </FormLabel>
              <RadioGroup
                value={String(formData.buffetGroup)}
                onChange={(e) => this.onInput('buffetGroup', Number(e.target.value))}
                className={css.formControls}
              >
                {WEEK_NUMBERS.map((number) => {
                  const str = number.toString()
                  return <FormControlLabel key={number} label={str} value={str} control={<Radio />} />
                })}
              </RadioGroup>
            </div>
            <div className={css.radioGroup}>
              <FormLabel required component='legend' className={css.formLabel}>
                {i18n.t('admin.stations.label.buffetBeginAt')}
              </FormLabel>
              <RadioGroup
                value={String(formData.buffetBeginAt)}
                onChange={(e) => this.onInput('buffetBeginAt', e.target.value)}
                className={css.formControls}
              >
                <FormControlLabel label='10:30' value='10:30:00' control={<Radio />} />
                <FormControlLabel label='11:00' value='11:00:00' control={<Radio />} />
              </RadioGroup>
            </div>
            <div className={css.radioGroup}>
              <FormLabel required component='legend' className={css.formLabel}>
                {i18n.t('admin.stations.label.buffetEndAt')}
              </FormLabel>
              <RadioGroup
                value={String(formData.buffetEndAt)}
                onChange={(e) => this.onInput('buffetEndAt', e.target.value)}
                className={css.formControls}
              >
                <FormControlLabel label='14:00' value='14:00:00' control={<Radio />} />
                <FormControlLabel label='15:00' value='15:00:00' control={<Radio />} />
                <FormControlLabel label='16:00' value='16:00:00' control={<Radio />} />
                <FormControlLabel label='17:00' value='17:00:00' control={<Radio />} />
                <FormControlLabel label='18:00' value='18:00:00' control={<Radio />} />
                <FormControlLabel label='19:00' value='19:00:00' control={<Radio />} />
                <FormControlLabel label='20:00' value='20:00:00' control={<Radio />} />
                <FormControlLabel label='21:00' value='21:00:00' control={<Radio />} />
              </RadioGroup>
            </div>
            <div className={css.actions}>
              <Button type='submit' color='primary' variant='contained' disabled={!this.isValid()}>
                {i18n.t('buttons.save')}
              </Button>
            </div>
          </form>
        )}
      </Mutation>
    )
  }
}

export default BuffetGeneralForm
